"use client"

import * as React from "react"
import { ProductProvider } from "@/components/shell/product-provider"

/**
 * exxat-home is a builder-facing demo app. Authoring (sign-in flows, product
 * settings, layout menus) stays on in production deploys. Consumer apps should
 * replace this with auth-backed `useCanAuthorProducts()` instead.
 */
export function ProductProviderRoot({
  children,
}: {
  children: React.ReactNode
}) {
  return <ProductProvider authoring>{children}</ProductProvider>
}
